import React from 'react';
import { Line, Tooltip, ResponsiveContainer, AreaChart, Area } from 'recharts';
import CustomTooltip from './CustomTooltip';

const GraphCell = ({ data, float, ...rest }) => {
  if (!data || data.length <= 0) {
    return null; // or some default UI indicating no data
  }

  const chartData = data.map(item => ({ 
    log_time: item.log_time,
    speed: item.speed,
  }));

  // Destructure and remove any non-DOM props
  const { focusElementRef, ...domProps } = rest;

  return (
    <div style={{ width: '100%', height: '100%' }} {...domProps}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart 
          data={chartData}
        >
          <Tooltip content={<CustomTooltip showname={0} float={float}/>} />
          <Line type="monotone" dataKey="speed" stroke="#FF724D" />
          <Area type="monotone" dataKey="speed" stroke="#FF724D" fill="#FFFFAA" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default GraphCell;